module.exports = __webpack_public_path__ + "img/202402_09.df41576d.jpg";